import React from "react";
import { DataService } from "../../data/DataService";
import { Link } from "react-router-dom";

function BreadcrumbSd({ id }) {
  return (
    <div>
      {/* Start Breadcrumb area  */}
      <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-inner text-center">
                <h1 className="title split-collab">
                  {DataService[`item${id}`]?.title}
                </h1>
                <ul className="page-list">
                  <li className="tmp-breadcrumb-item">
                    <Link to="/">Accueil</Link>
                  </li>
                  <li className="icon">
                    <i className="fa-solid fa-angle-right" />
                  </li>
                  <li className="tmp-breadcrumb-item">
                    <Link to="/departements">Departements</Link>
                  </li>
                  <li className="icon">
                    <i className="fa-solid fa-angle-right" />
                  </li>
                  <li className="tmp-breadcrumb-item active">
                    {DataService[`item${id}`]?.title}
                  </li>
                </ul>
                <div className="circle-1" />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="tmp-ocean">
          <div className="ocean">
            <div className="wave" />
            <div className="wave" />
          </div>
        </div> */}
      </div>
      {/* End Breadcrumb area  */}
    </div>
  );
}

export default BreadcrumbSd;
